import { IAllowanceTransaction } from "../config/allowance";
import {IErrorResponseItem, ValidationError, ValidationErrors} from "../services/validator";
import { TransactionValidationField } from "./transactions";

export type TransactionAllowanceValidation = {
    [key in TransactionValidationField]?: ValidationError[];
};

export type TransactionAllowanceValidationErrors = ValidationErrors<TransactionAllowanceValidation, TransactionValidationField>;

export const transactionAllowanceValidationFactory = (errors: IErrorResponseItem[]): TransactionAllowanceValidationErrors => {
    const v = new ValidationErrors<TransactionAllowanceValidation, TransactionValidationField>();
    v.setMap({
        allowance_id: TransactionValidationField.ALLOWANCE_ID,
        amount: TransactionValidationField.ALLOWANCE_AMOUNT,
    });
    v.setErrors(errors);

    return v;
};

export const validateTransactionAllowanceForm = (data: IAllowanceTransaction): TransactionAllowanceValidationErrors => {
    const errors = transactionAllowanceValidationFactory([]);

    if (!data.allowance_id) {
        errors.add(TransactionValidationField.ALLOWANCE_ID, ValidationError.REQUIRED);
    }
    if (!data.amount) {
        errors.add(TransactionValidationField.ALLOWANCE_AMOUNT, ValidationError.REQUIRED);
    }

    return errors;
};
